import * as React from "react";
const SVGComponent = ({ color, ...props }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1397_25185)">
      <path
        d="M9.9974 18.3334C14.5998 18.3334 18.3307 14.6025 18.3307 10.0001C18.3307 5.39771 14.5998 1.66675 9.9974 1.66675C5.39502 1.66675 1.66406 5.39771 1.66406 10.0001C1.66406 14.6025 5.39502 18.3334 9.9974 18.3334Z"
        fill={color}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1641 7.5L9.00781 12.6562L6.66406 10.3125"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1397_25185">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;

SVGComponent.defaultProps = {
  color: "#CCCCCC",
};
